import axios from './axios.js'
// import url from './urls.js'

export default {
  // Projects
  // getProjects: (data) => axios.get(`${url.project}?${new URLSearchParams(data).toString()}`),
  // addProject: (data) => axios.post(url.project, data.params),
  // renameProject: (data) => axios.put(`${url.project}`, data.params)
  // deleteProjects: (data) => axios.delete(url.project, { data: data.params })

  newMaskedText: (data) => axios.post(process.env.VUE_APP_MASKING_API_ENDPOINT, data),

  // File Upload
  uploadFile: (formData) =>
    axios.post(process.env.VUE_APP_FILE_UPLOAD_ENDPOINT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),

  // TTS (Text-to-Speech)
  textToSpeech: (data) =>
    axios.post(process.env.VUE_APP_TTS_API_ENDPOINT, data, {
      headers: {
        'Content-Type': 'application/json',
        access_token: process.env.VUE_APP_TTS_ACCESS_TOKEN
      }
    })
}
